export default __webpack_public_path__ + "static/media/compass.3e1696f8.svg";